/*
 * Copyright (c) 2018-2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
/// <reference types="cache-fm" />
import { IResourceProps } from 'apmui/resource/ResourceLoader';
import { RESOURCE } from 'apmui/resource/ResourceType';
import { WebtopResourceModel } from 'apmui/resource/WebtopResourceModel';

function launchPortalAccessResource(uri: string) {
    if (window.F5_Invoke_open) {
        window.F5_Invoke_open(window, 'open', uri, '_blank', '');
    }
}

class PortalAccessModel extends WebtopResourceModel {
    static readonly propNames = ['application_uri', 'publish_on_webtop', ...WebtopResourceModel.propNames];

    type: RESOURCE.PORTAL_ACCESS = RESOURCE.PORTAL_ACCESS;
    applicationUri: string;
    hidden: boolean;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.applicationUri = resource.props.application_uri;
        this.hidden = resource.props.publish_on_webtop === '0';
        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return PortalAccessModel.propNames;
    }

    launchResource() {
        launchPortalAccessResource(this.applicationUri);
    }
}

export { PortalAccessModel as default, launchPortalAccessResource };
